// extracted by mini-css-extract-plugin
module.exports = {"branch":"SingleBranch_branch__stYZK","branch__active":"SingleBranch_branch__active__iT3mg","left":"SingleBranch_left__3hvPJ","right":"SingleBranch_right__YMHp4"};